module.exports = __webpack_public_path__ + "static/media/ico-dashboard.cd84ab7c.svg";